import { getTestId, LILAC_300 } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  wrapperStyle: {},
  containerStyle: {
    backgroundColor: LILAC_300
  },
  containerProps: {},
  crossContainerStyle: {},
  height: 400,
  width: 400,
  id: 'ModalSectionContainer'
}, getTestId('ModalSectionContainer'));